import React from 'react';
function EirCustomiseClearCart(props){
    return (      
        <div className="customise_cart__empty__position">           
                <div><div className="customise_cart__empty__icon"></div></div>
                <div className="customise_cart__empty__heading">Looks like your cart is empty</div>
                <div className="customise_cart__empty__subtext">Why not take a look at some of our great bundle offers?</div>
                <div className="customise_cart_empty_button_position">
                <a href="/broadband/" className="customise_cart_empty_button">View bundles</a>
                </div>
                            
        </div>
   ); 
}export default EirCustomiseClearCart;